import { SchemaFieldConstants } from '../../generic/serialization/constants';
import { SchemaField } from '../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

export class ConversationSpamDetectionConfigSchema extends SerializableObjectSchema {
  public static readonly enabled = 'enabled';

  public static readonly instructions = 'instructions';

  public static readonly spamDetectedMessage = 'spamDetectedMessage';

  public static readonly spamFilteringPassedMessage = 'spamFilteringPassedMessage';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly enabled = false;

    public static readonly instructions = '';

    public static readonly spamDetectedMessage = '';

    public static readonly spamFilteringPassedMessage = '';
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Default Values To Serialize
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public defaultValuesToSerialize(): Set<string> {
    return new Set([
      ConversationSpamDetectionConfigSchema.enabled,
      ConversationSpamDetectionConfigSchema.instructions,
      ConversationSpamDetectionConfigSchema.spamDetectedMessage,
      ConversationSpamDetectionConfigSchema.spamFilteringPassedMessage,
    ]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    parameters[ConversationSpamDetectionConfigSchema.enabled] = SchemaField.boolean(
      ConversationSpamDetectionConfigSchema.Defaults.enabled,
    );
    parameters[ConversationSpamDetectionConfigSchema.instructions] = SchemaField.string(
      ConversationSpamDetectionConfigSchema.Defaults.instructions,
      undefined,
      SchemaFieldConstants.longStringMaxLength,
    );
    parameters[ConversationSpamDetectionConfigSchema.spamDetectedMessage] = SchemaField.string(
      ConversationSpamDetectionConfigSchema.Defaults.spamDetectedMessage,
    );
    parameters[ConversationSpamDetectionConfigSchema.spamFilteringPassedMessage] = SchemaField.string(
      ConversationSpamDetectionConfigSchema.Defaults.spamFilteringPassedMessage,
    );

    return parameters;
  }
}
